import { QuestionId, QuestionsCollection } from '../../../api/models/survey';
import { OrderAttendee } from '../../../models/attendee';
import { AttendeeSurvey, getBuiltSurvey } from '../../../models/survey';

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const buildAttendeeSurveys = (
    attendees: Array<OrderAttendee> = [],
    questions: QuestionsCollection,
    shouldIncludeQuestionHelper: (questionId: QuestionId) => boolean,
) =>
    attendees.reduce<Array<AttendeeSurvey>>(
        (
            attendeeSurvey,
            { id, survey = [], ticketClass, ticketClassName },
            index,
        ) =>
            survey.length > 0
                ? [
                      ...attendeeSurvey,
                      {
                          id,
                          survey: getBuiltSurvey(
                              questions,
                              survey,
                              shouldIncludeQuestionHelper,
                          ),
                          ticketClassCategory: ticketClass?.category,
                          ticketClassName,
                          ticketNumber: index + 1,
                      },
                  ]
                : attendeeSurvey,
        [],
    );
